<div class="ec-subjects-summary-container" fxLayout="column" fxLayoutGap="30px"
     *appVar="hierarchyEntity|async as entity">

    <app-filter-bar
            [showNullData]="showNullData"
            [config]="billingPeriodCfg"
            [billingPeriod]="billingPeriod"
            [useFilter]="true"
            [showGSEBtn]="false"
            (billingPeriodEventEmitter)="onChangeBillingPeriod($event)">
    </app-filter-bar>

    <div *ngIf="isWholeYear && isDefined(strategyFeatures) && strategyFeatures.features[ECEconomicsFeatures.SURPLUS_PREMIUM_RATE]" fxLayout="column" fxLayoutAlign="center" fxLayoutGap="12px" class="panel-tip p-16">
        <div fxLayout="row" fxLayoutGap="12px">
            <div class="txt-h-18-7">{{'Exceeding amount'|i18n}}</div>
            <app-icon icon-color-h name="fas-info-circle"
                      [title]="'Eventual amount of premium incentive that exceeds the incentiveable shared energy threshold. This should be set aside or allocated to private absorbing members in proportion to the incentive they already get.'|i18n"></app-icon>
        </div>
        <div class="txt-p-12-4">
            {{('TIP allocated to enterprises due to plants redistribution and absorption - Maximum TIP redistributable for companies'|i18n) + ':'}}
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="12px">
                <div class="txt-h-12-4">
                    {{ showNullData || !isDefined(exceedingTipTotals) ? '€ -' :
                        (exceedingTipTotals.totalPrivateTip|niceValue: '€':2: exceedingTipTotals.totalPrivateTip < 0) + ' - ' + (exceedingTipTotals?.maxPrivateTip|niceValue: '€':2: exceedingTipTotals?.maxPrivateTip < 0) + ' ='}}
                </div>
                <div class="txt-h-16-7">
                    {{showNullData || !isDefined(exceedingTipTotals) ? '€ -' :
                    ((exceedingTipTotals.exceedingQuota)|niceValue: '€':2: exceedingTipTotals.exceedingQuota < 0)}}
                </div>
            </div>
            <div *ngIf="exceedingTipTotals?.quotaScope === ECSurplusPremiumRateScope.ALLOCATED" fxLayout="row" fxLayoutAlign="space-around center"
                 class="txt-s-14-4" fxLayoutGap="8px">
                <app-icon name="fal-arrow-right"></app-icon>
                <app-icon name="fal-piggy-bank"></app-icon>
                <div>{{'Saved as fund'|i18n}}</div>
            </div>
            <div *ngIf="exceedingTipTotals?.quotaScope === ECSurplusPremiumRateScope.CONSUMER_REDISTRIBUTED" fxLayout="row" fxLayoutAlign="space-around center"
                 class="txt-s-14-4" fxLayoutGap="8px">
                <app-icon name="fal-arrow-right"></app-icon>
                <app-icon name="fal-plug"></app-icon>
                <div>{{'Intended for non-enterprise absorptions'|i18n}}</div>
            </div>
            <div *ngIf="exceedingTipTotals?.quotaScope === ECSurplusPremiumRateScope.UNDEFINED"
                 fxLayout="row" fxLayoutAlign="space-around center"
                 class="txt-s-14-4" fxLayoutGap="8px">
                <app-icon name="fas-exclamation-triangle" icon-color-w
                          [title]="'Use the algorithm configuration form to choose where to allocate this amount.'|i18n"></app-icon>
                <app-icon name="fal-arrow-right"></app-icon>
                <div>{{'To be allocated'|i18n}}</div>
            </div>
        </div>
    </div>

    <ng-container *ngIf="entity && isViewable(entity); else unviewableEntity">
        <div *ngIf="!loadingSubjects && !inactiveEc && !futureEc" fxLayout="column" fxLayoutGap="20px">
            <!-- estimated data label -->
            <div fxLayout="row" fxLayoutAlign="end center">
                <app-consolidation-info-bar
                        [billingPeriod]=billingPeriodSubj.asObservable()
                        [timeZone]="timeZone"
                        [summaryResponse]=summaryResponseSubject.asObservable()>
                </app-consolidation-info-bar>
            </div>
        </div>
    </ng-container>

    <!-- TABLE RELATED STUFF -->
    <div fxLayout="column" class="table-container">
        <ng-container *appVar="subjects|async as subjects">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                <div class="txt-h-20-7">{{ 'Amounts per subject'|i18n }}</div>
                <app-icon *ngIf="communityNotConfigured" icon-color-w name="fas-exclamation-triangle"
                          [title]="'Please make sure that community costs, plants withdrawal quote and plants tip quote are configured'|i18n">
                </app-icon>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-12">
                <div app-input-container class="find-subject-container" fxFlex="none">
                    <input app-input autocomplete="off"
                           class="find-subject txt-s-16-4"
                           [(ngModel)]="searchText"
                           [disabled]="futureEc || inactiveEc"
                           (ngModelChange)="onClickSearchText()"
                           [spellcheck]="false" [placeholder]="'Search by subject name'|i18n">
                    <app-icon *ngIf="searchText && searchText.length > 0" name="fal-times" class="right-symbol clear"
                              (click)="onClickClearSearchText()">
                    </app-icon>
                    <svg *ngIf="!searchText || searchText.length === 0" xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 512 512"
                         class="right-symbol mag-glass">
                        <!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                        <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z"/>
                    </svg>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
                    <div>{{('Filter by subject type'|i18n) + ':'}}</div>
                    <div fxFlex app-input-container>
                        <mat-select app-small-select
                                    class="status-filter"
                                    [placeholder]="'Subject type'|i18n"
                                    [formControl]="typeFilterControl"
                                    [disabled]="futureEc || inactiveEc"
                                    multiple>
                            <mat-option *ngFor="let type of allTypesForFilter" [value]="type"
                                        class="mat-primary">
                                {{(type|filteringTypesTranslation)|i18n}}
                            </mat-option>
                        </mat-select>
                    </div>
                    <div fxLayout="row">
                        <button app-small-ghost-button class="app-base-button"
                                [disabled]="futureEc || inactiveEc"
                                (click)="resetFilters()">
                            {{'Reset filters'|i18n}}
                        </button>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="!loadingSubjects; else loadingEconomics">
                <ng-container *ngIf="!!subjects && subjects.total > 0">
                    <table mat-table app-table [dataSource]="subjects.subjects" multiTemplateDataRows
                           class="subject-table mt-16">
                        <ng-container matColumnDef="subjects">
                            <th mat-header-cell *matHeaderCellDef class="width-15">
                                <div fxLayout="row" fxLayoutAlign="start center">
                                    <div fxFlex="10"></div>
                                    <span class="txt-h-16-5 ml-4">{{ 'Subject'|i18n }}</span>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="space-between center">
                                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="75">
                                        <div fxFlex="15"></div>
                                        <div class="txt-p-14-4" [style]="{'white-space': 'nowrap'}">
                                            {{ getNameFor(row.member.personal_data) }}
                                        </div>
                                    </div>
                                    <div class="icon-container" [ngClass]="getIconAndColorBasedOnJuridicalData(row.member.juridical_type,
                                    row.member.legal_form, row.member.subject_type)[1]" fxFlex="25" fxLayoutAlign="center center">
                                        <app-icon [name]="getIconAndColorBasedOnJuridicalData(row.member.juridical_type,
                                        row.member.legal_form, row.member.subject_type)[0]"
                                        [title]="getTitleBasedOnJuridicalData(row.member.subject_type,row.member.legal_form)|i18n"></app-icon>
                                    </div>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="plants_incentive">
                            <th mat-header-cell *matHeaderCellDef>
                                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
                                    <span class="txt-h-16-5">{{ 'Plants incentive'|i18n }}</span>
                                    <app-icon name="fas-info-circle"
                                              [title]="'Includes amounts allocated to the PV related to the TIP and Cacv (if allocated to the PVs), if any'|i18n">
                                    </app-icon>
                                    <button *ngIf="getSortDirection(SortCriterion.PLANTS_INCENTIVE) === SortDirection.ASC"
                                            app-icon-button class="sort-button"
                                            (click)="onClickSortBy(SortCriterion.PLANTS_INCENTIVE, SortDirection.DESC)">
                                        <app-icon name="fal-sort-amount-up"></app-icon>
                                    </button>
                                    <button *ngIf="getSortDirection(SortCriterion.PLANTS_INCENTIVE) === SortDirection.DESC"
                                            app-icon-button class="sort-button"
                                            (click)="onClickSortBy(SortCriterion.PLANTS_INCENTIVE, SortDirection.ASC)">
                                        <app-icon name="fal-sort-amount-down"></app-icon>
                                    </button>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div fxLayout="column" fxLayoutAlign="space-around end">
                                    <div class="txt-h-14-7" fxLayoutAlign="center center"
                                         [ngClass]="{'overwrite-color': row.subject.gse}">
                                        <span *ngIf="!communityNotConfigured">
                                            {{ row.subject.plants_incentive|niceValue: '€': 2 : row.subject.plants_incentive < 0}}
                                        </span>
                                        <span *ngIf="communityNotConfigured">
                                            {{ '€ -' }}
                                        </span>
                                    </div>
                                    <div class="txt-h-14-4" fxLayoutAlign="center center">
                                        <span *ngIf="!communityNotConfigured">
                                            {{ ('(from TIP: '|i18n) + (row.subject.plants_tip|niceValue: '€': 2: row.subject.plants_tip < 0) + ')' }}
                                        </span>
                                        <span *ngIf="communityNotConfigured">
                                            {{ ('(from TIP: '|i18n) + '€ -' + ')' }}
                                        </span>
                                    </div>
                                    <div class="txt-h-14-4" fxLayoutAlign="center center">
                                        <span *ngIf="!communityNotConfigured"
                                              [innerHTML]="('(from {0}: '|i18n:CACV_STRING)
                                              + (row.subject.plants_cacv|niceValue: '€': 2: row.subject.plants_cacv < 0) + ')'"></span>
                                        <span *ngIf="communityNotConfigured"
                                              [innerHTML]="('(from {0}: '|i18n:CACV_STRING)
                                              + '€ -' + ')'"></span>
                                    </div>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="absorption_revenue">
                            <th mat-header-cell *matHeaderCellDef>
                                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
                                    <div fxLayout="column" fxLayoutAlign="center center">
                                        <span class="txt-h-16-7">{{ 'Absorption incentive'|i18n }}</span>
                                    </div>
                                    <app-icon name="fas-info-circle"
                                              [title]="'The plants absorption rei is based on absorption incentives and comes from the self-consumption configurations plants withdrawal.'|i18n">
                                    </app-icon>
                                    <button *ngIf="getSortDirection(SortCriterion.ABSORPTION_REVENUE) === SortDirection.ASC"
                                            app-icon-button class="sort-button"
                                            (click)="onClickSortBy(SortCriterion.ABSORPTION_REVENUE, SortDirection.DESC)">
                                        <app-icon name="fal-sort-amount-up"></app-icon>
                                    </button>
                                    <button *ngIf="getSortDirection(SortCriterion.ABSORPTION_REVENUE) === SortDirection.DESC"
                                            app-icon-button class="sort-button"
                                            (click)="onClickSortBy(SortCriterion.ABSORPTION_REVENUE, SortDirection.ASC)">
                                        <app-icon name="fal-sort-amount-down"></app-icon>
                                    </button>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div fxLayout="column" fxLayoutAlign="space-around end">
                                    <div class="txt-h-14-7" fxLayoutAlign="space-around center" fxLayoutGap="8px"
                                         [ngClass]="{'overwrite-color': row.subject.gse}">
                                        <span *ngIf="!communityNotConfigured">
                                            {{ row.subject.absorption_revenue|niceValue: '€': 2 : row.subject.absorption_revenue < 0}}
                                        </span>
                                        <span *ngIf="!communityNotConfigured">
                                            <app-icon *ngIf="missingRedistributionParam()" [title]="'Please configure the redistribution algorithm'|i18n"
                                                      icon-color-w name="fas-exclamation-triangle">
                                            </app-icon>
                                        </span>
                                        <span *ngIf="communityNotConfigured">
                                            {{ '€ -' }}
                                        </span>
                                    </div>
                                    <div class="txt-h-14-4" fxLayoutAlign="center center">
                                        <span *ngIf="!communityNotConfigured">
                                            {{ ('(from TIP: '|i18n) + (row.subject.absorption_tip|niceValue: '€': 2: row.subject.absorption_tip < 0) + ')' }}
                                        </span>
                                        <span *ngIf="communityNotConfigured">
                                            {{ ('(from TIP: '|i18n) + '€ -' + ')' }}
                                        </span>
                                    </div>
                                    <div class="txt-h-14-4" fxLayoutAlign="center center">
                                        <span *ngIf="!communityNotConfigured"
                                              [innerHTML]="('(from {0}: '|i18n:CACV_STRING)
                                              + (row.subject.absorption_cacv|niceValue: '€': 2: row.subject.absorption_cacv <0) + ')'"></span>
                                        <span *ngIf="communityNotConfigured"
                                              [innerHTML]="('(from {0}: '|i18n:CACV_STRING)
                                              + '€ -' + ')'"></span>
                                    </div>
                                    <div class="txt-h-14-4 margin-top-minus-4" fxLayoutAlign="center center">
                                        <span *ngIf="!communityNotConfigured">
                                            {{ ('(from withdrawal: '|i18n) + (row.subject.absorption_ec_plants_rei|niceValue: '€': 2: row.subject.absorption_ec_plants_rei <0) + ')' }}
                                        </span>
                                        <span *ngIf="communityNotConfigured">
                                            {{ ('(from withdrawal: '|i18n) + '€ -' + ')' }}
                                        </span>
                                    </div>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="shared_energy_per_capita">
                            <th mat-header-cell *matHeaderCellDef class="width-25">
                                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
                                    <span class="txt-h-16-5">{{ 'Shared energy per capita'|i18n }}</span>
                                    <button *ngIf="getSortDirection(SortCriterion.RELEVANT_ENERGY) === SortDirection.ASC"
                                            app-icon-button class="sort-button"
                                            (click)="onClickSortBy(SortCriterion.RELEVANT_ENERGY, SortDirection.DESC)">
                                        <app-icon name="fal-sort-amount-up"></app-icon>
                                    </button>
                                    <button *ngIf="getSortDirection(SortCriterion.RELEVANT_ENERGY) === SortDirection.DESC"
                                            app-icon-button class="sort-button"
                                            (click)="onClickSortBy(SortCriterion.RELEVANT_ENERGY, SortDirection.ASC)">
                                        <app-icon name="fal-sort-amount-down"></app-icon>
                                    </button>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div *ngIf="!communityNotConfigured" fxLayout="row" fxLayout.lt-lg="column"
                                     fxLayoutAlign="space-around center"
                                     fxLayoutGap="12px" fxLayoutGap.lt-lg="4px">
                                    <div class="details-text"
                                         fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="4px"
                                         fxFlex="34" fxFlex.lt-lg="30">
                                        <app-icon *ngIf="!!row.subject.relevant_consumption_energy" name="fal-plug"
                                                  class="grey-icon"></app-icon>
                                        <span *ngIf="!!row.subject.relevant_consumption_energy">
                                            {{ row.subject.relevant_consumption_energy|niceValue:'kWh' }}
                                        </span>
                                        <span *ngIf="!!row.subject.relevant_consumption_energy">
                                            {{ (row.subject.relevant_consumption_ratio) * 100|niceValue:'%' }}
                                        </span>
                                    </div>
                                    <div class="details-text"
                                         fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="4px"
                                         fxFlex="34" fxFlex.lt-lg="30">
                                        <app-icon *ngIf="!!row.subject.relevant_production_energy" name="fal-solar-panel"
                                                  class="grey-icon"></app-icon>
                                        <span *ngIf="!!row.subject.relevant_production_energy">
                                            {{ row.subject.relevant_production_energy|niceValue:'kWh' }}
                                        </span>
                                        <span *ngIf="!!row.subject.relevant_production_energy">
                                            {{ (row.subject.relevant_production_ratio) * 100|niceValue:'%' }}
                                        </span>
                                    </div>
                                    <div class="details-text-2" fxLayout="row"
                                         fxLayoutAlign="space-between center" fxLayoutGap="4px"
                                         fxFlex="26" fxFlex.lt-lg="30">
                                        <span>{{ 'Tot. ' }}</span>
                                        <span>{{ row.subject.relevant_energy|niceValue:'kWh' }}</span>
                                    </div>
                                </div>
                                <div *ngIf="communityNotConfigured" fxLayoutAlign="center center">
                                    <span *ngIf="communityNotConfigured">
                                        {{ '-' }}
                                    </span>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="contribution_reduction_co2">
                            <th mat-header-cell *matHeaderCellDef>
                                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
                                    <div fxLayout="row" fxLayoutGap="6px">
                                        <span class="txt-h-16-5">{{ 'Fee reduction {0}'|i18n:'CO&#8322;' }}</span>
                                        <app-icon name="fas-info-circle" [title]="'Based on shared energy'|i18n">
                                        </app-icon>
                                    </div>
                                    <button *ngIf="getSortDirection(SortCriterion.CONTRIBUTION_REDUCTION_CO2) === SortDirection.ASC"
                                            app-icon-button class="sort-button"
                                            (click)="onClickSortBy(SortCriterion.CONTRIBUTION_REDUCTION_CO2, SortDirection.DESC)">
                                        <app-icon name="fal-sort-amount-up"></app-icon>
                                    </button>
                                    <button *ngIf="getSortDirection(SortCriterion.CONTRIBUTION_REDUCTION_CO2) === SortDirection.DESC"
                                            app-icon-button class="sort-button"
                                            (click)="onClickSortBy(SortCriterion.CONTRIBUTION_REDUCTION_CO2, SortDirection.ASC)">
                                        <app-icon name="fal-sort-amount-down"></app-icon>
                                    </button>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div class="txt-h-14-7" fxLayoutAlign="center center">
                                    <span *ngIf="!communityNotConfigured">
                                        {{ row.subject.saved_co2 / 1000000|niceValue:'t' }}
                                    </span>
                                    <span *ngIf="communityNotConfigured">
                                        {{ '- t' }}
                                    </span>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="subject_revenue">
                            <th mat-header-cell *matHeaderCellDef>
                                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
                                    <span class="txt-h-18-7">{{ 'Subject total'|i18n }}</span>
                                    <button *ngIf="getSortDirection(SortCriterion.SUBJECT_REVENUE) === SortDirection.ASC"
                                            app-icon-button class="sort-button"
                                            (click)="onClickSortBy(SortCriterion.SUBJECT_REVENUE, SortDirection.DESC)">
                                        <app-icon name="fal-sort-amount-up"></app-icon>
                                    </button>
                                    <button *ngIf="getSortDirection(SortCriterion.SUBJECT_REVENUE) === SortDirection.DESC"
                                            app-icon-button class="sort-button"
                                            (click)="onClickSortBy(SortCriterion.SUBJECT_REVENUE, SortDirection.ASC)">
                                        <app-icon name="fal-sort-amount-down"></app-icon>
                                    </button>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div class="txt-h-18-7" fxLayoutAlign="center center" [ngClass]="{'overwrite-color': row.subject.gse}">
                                    <span *ngIf="!communityNotConfigured">
                                        {{ row.subject.subject_revenue|niceValue: '€': 2 : row.subject.subject_revenue <0}}
                                    </span>
                                    <span *ngIf="communityNotConfigured">
                                        {{ '€ -' }}
                                    </span>
                                </div>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                            class="app-row app-border-upper-row"
                            [ngClass]="{'app-border-upper-row': !row.pod}"></tr>
                    </table>
                    <mat-divider></mat-divider>
                </ng-container>
                <div *ngIf="!subjects || subjects.total === 0" fxLayout="row" fxLayoutAlign="center">
                    {{ 'No subjects found'|i18n }}
                </div>
            </ng-container>
            <mat-paginator #paginator app-paginator class="member-paginator"
                           [ngClass]="{'collapsed': !subjects || subjects.total === 0}"
                           [length]="subjects?.total" [pageSize]="DEFAULT_PAGE_SIZE" [pageSizeOptions]="DEFAULT_PAGE_SIZES">
            </mat-paginator>
        </ng-container>
    </div>

    <ng-container *appVar="subjects|async as subs">
        <div class="table-totals" *ngIf="!loadingSubjects && !!subs && subs.total > 0">
            <table mat-table app-table [dataSource]="[tableTotals]" multiTemplateDataRows
                   class="subject-table">
                <ng-container matColumnDef="subjects">
                    <th mat-header-cell *matHeaderCellDef class="hidden-header"></th>
                    <td mat-cell *matCellDef="let row" class="width-15">
                        <div fxLayoutAlign="space-around center" fxLayoutGap="8px">
                            <div class="txt-h-18-7">{{'Subjects in table totals'|i18n}}</div>
                            <app-icon name="fas-info-circle" class="txt-h-18-7"
                                      [title]="('Data shows totals of all subjects in the table, comprehending all pages and filters applied.'|i18n)">
                            </app-icon>
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="plants_incentive">
                    <th mat-header-cell *matHeaderCellDef class="width-12 hidden-header"></th>
                    <td mat-cell *matCellDef="let row" class="width-12">
                        <div fxLayout="column" fxLayoutAlign="space-around end">
                            <div class="txt-h-14-7" fxLayoutAlign="center center"
                                 [ngClass]="{'overwrite-color': row.gse}">
                            <span *ngIf="!communityNotConfigured">
                                {{ row.plants_incentive|niceValue: '€': 2 : row.plants_incentive < 0}}
                            </span>
                                <span *ngIf="communityNotConfigured">
                                {{ '€ -' }}
                            </span>
                            </div>
                            <div class="txt-h-14-4" fxLayoutAlign="center center">
                            <span *ngIf="!communityNotConfigured">
                                {{ ('(from TIP: '|i18n) + (row.plants_tip|niceValue: '€': 2: row.plants_tip < 0) + ')' }}
                            </span>
                                <span *ngIf="communityNotConfigured">
                                {{ ('(from TIP: '|i18n) + '€ -' + ')' }}
                            </span>
                            </div>
                            <div class="txt-h-14-4" fxLayoutAlign="center center">
                            <span *ngIf="!communityNotConfigured"
                                  [innerHTML]="('(from {0}: '|i18n:CACV_STRING)
                                  + (row.plants_cacv|niceValue: '€': 2: row.plants_cacv < 0) + ')'"></span>
                                <span *ngIf="communityNotConfigured"
                                      [innerHTML]="('(from {0}: '|i18n:CACV_STRING)
                                  + '€ -' + ')'"></span>
                            </div>
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="absorption_revenue">
                    <th mat-header-cell *matHeaderCellDef class="width-16 hidden-header"></th>
                    <td mat-cell *matCellDef="let row" class="width-16">
                        <div fxLayout="column" fxLayoutAlign="space-around end">
                            <div class="txt-h-14-7" fxLayoutAlign="center center"
                                 [ngClass]="{'overwrite-color': row.gse}">
                            <span *ngIf="!communityNotConfigured">
                                {{ row.absorption_revenue|niceValue: '€': 2 :  row.absorption_revenue < 0}}
                            </span>
                                <span *ngIf="communityNotConfigured">
                                {{ '€ -' }}
                            </span>
                            </div>
                            <div class="txt-h-14-4" fxLayoutAlign="center center">
                            <span *ngIf="!communityNotConfigured">
                                {{ ('(from TIP: '|i18n) + (row.absorption_tip|niceValue: '€': 2: row.absorption_tip < 0) + ')' }}
                            </span>
                                <span *ngIf="communityNotConfigured">
                                {{ ('(from TIP: '|i18n) + '€ -' + ')' }}
                            </span>
                            </div>
                            <div class="txt-h-14-4" fxLayoutAlign="center center">
                            <span *ngIf="!communityNotConfigured"
                                  [innerHTML]="('(from {0}: '|i18n:CACV_STRING)
                                  + (row.absorption_cacv|niceValue: '€': 2: row.absorption_cacv < 0) + ')'"></span>
                                <span *ngIf="communityNotConfigured"
                                      [innerHTML]="('(from {0}: '|i18n:CACV_STRING)
                                  + '€ -' + ')'"></span>
                            </div>
                            <div class="txt-h-14-4 margin-top-minus-4" fxLayoutAlign="center center">
                            <span *ngIf="!communityNotConfigured">
                                {{ ('(from withdrawal: '|i18n) + (row.absorption_ec_plants_rei|niceValue: '€': 2: row.absorption_ec_plants_rei < 0) + ')' }}
                            </span>
                                <span *ngIf="communityNotConfigured">
                                {{ ('(from withdrawal: '|i18n) + '€ -' + ')' }}
                            </span>
                            </div>
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="shared_energy_per_capita">
                    <th mat-header-cell *matHeaderCellDef class="width-25 hidden-header"></th>
                    <td mat-cell *matCellDef="let row" class="width-25">
                        <div *ngIf="!communityNotConfigured" fxLayout="row" fxLayout.lt-lg="column"
                             fxLayoutAlign="space-around center" fxLayoutGap="12px" fxLayoutGap.lt-lg="4px">
                            <div class="details-text" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px"
                                 fxFlex="34" fxFlex.lt-lg="30">
                                <app-icon *ngIf="!!row.relevant_consumption_energy" name="fal-plug"
                                          class="grey-icon"></app-icon>
                                <span *ngIf="!!row.relevant_consumption_energy">
                                {{ row.relevant_consumption_energy|niceValue:'kWh' }}
                            </span>
                            </div>
                            <div class="details-text" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px"
                                 fxFlex="34" fxFlex.lt-lg="30">
                                <app-icon *ngIf="!!row.relevant_production_energy" name="fal-solar-panel"
                                          class="grey-icon"></app-icon>
                                <span *ngIf="!!row.relevant_production_energy">
                                {{ row.relevant_production_energy|niceValue:'kWh' }}
                            </span>
                            </div>
                            <div class="details-text-2" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px"
                                 fxFlex="26" fxFlex.lt-lg="30">
                                <span>{{ 'Tot. ' }}</span>
                                <span>{{ row.relevant_energy|niceValue:'kWh' }}</span>
                            </div>
                        </div>
                        <div *ngIf="communityNotConfigured" fxLayoutAlign="center center">
                        <span *ngIf="communityNotConfigured">
                            {{ '-' }}
                        </span>
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="contribution_reduction_co2">
                    <th mat-header-cell *matHeaderCellDef class="width-15 hidden-header"></th>
                    <td mat-cell *matCellDef="let row" class="width-15">
                        <div class="txt-h-14-7" fxLayoutAlign="center center">
                                    <span *ngIf="!communityNotConfigured">
                                        {{ row.saved_co2 / 1000000|niceValue:'t' }}
                                    </span>
                            <span *ngIf="communityNotConfigured">
                                        {{ '- t' }}
                                    </span>
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="subject_revenue">
                    <th mat-header-cell *matHeaderCellDef class="width-15 hidden-header"></th>
                    <td mat-cell *matCellDef="let row" class="width-15">
                        <div class="txt-h-18-7" fxLayoutAlign="center center" [ngClass]="{'overwrite-color': row.gse}">
                                    <span *ngIf="!communityNotConfigured">
                                        {{ row.subject_revenue|niceValue: '€': 2 :  row.subject_revenue < 0}}
                                    </span>
                            <span *ngIf="communityNotConfigured">
                                        {{ '€ -' }}
                                    </span>
                        </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns" class="hidden-header"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                    class="app-row"></tr>
            </table>
        </div>
    </ng-container>
</div>

<ng-template #loadingEconomics>
    <div fxLayout="column" fxLayoutAlign="space-around center">
        <div fxLayout="row" fxLayoutAlign="center center" class="mt-24 mb-16">
            <mat-spinner app-spinner diameter="20"></mat-spinner>
            <span class="pl-8">{{ 'Loading'|i18n }}...</span>
        </div>
        <div *ngIf="showComputationWarning" fxLayout="row" fxLayoutAlign="center center"
             fxLayoutGap="30px" economics-warning class="mt-30 padding-14">
            <app-icon icon-color-w name="fas-info-circle"></app-icon>
            <div>{{ 'We are recalculating the economics data due to an updated configuration parameter.'|i18n }}</div>
        </div>
    </div>
</ng-template>

<ng-template #unviewableEntity>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-16">
        {{ 'Insufficient permissions to view this resource'|i18n }}
    </div>
</ng-template>

<ng-template #ecWaitingForApproval>
    <div fxLayout="column" class="p-30" fxLayoutAlign="center center">
        <div class="txt-h-24-7">{{ 'Community waiting for activation'|i18n }}</div>
        <app-icon icon-color-h name="fal-clock" fxFlex="60" class="clock-icon mt-30 mb-30"></app-icon>
        <ng-container *ngIf="inactiveEc">
            <div class="txt-s-16-4">{{ 'This community has no activation date yet.'|i18n }}</div>
            <div class="txt-s-16-4">{{ 'As soon as the community is activated, you will see economic and energy data here.'|i18n }}</div>
        </ng-container>
        <ng-container *ngIf="!inactiveEc">
            <div class="txt-s-16-4">{{ 'This community will be activated by {0}.'|i18n:(billingPeriodCfg.pastDate|i18nDate) }}</div>
            <div class="txt-s-16-4">{{ 'Economic data will be available from that day.'|i18n }}</div>
        </ng-container>
        <div mat-dialog-actions class="dialog-actions mt-30">
            <button app-primary-button [mat-dialog-close]="true">
                {{ 'Ok'|i18n }}
            </button>
        </div>
    </div>
</ng-template>
